export const adminTranscriptReviewKeys = {
  all: [{ module: 'adminTranscriptReview' }] as const,
  sessions: () => [{ ...adminTranscriptReviewKeys.all[0], scope: 'sessions' }] as const,
  sessionsByJob: (jobId: string) => [{ ...adminTranscriptReviewKeys.sessions()[0], jobId }] as const,
  styleFixManifests: () => [{ ...adminTranscriptReviewKeys.all[0], scope: 'styleFixManifest' }] as const,
  styleFixManifest: (jobId: string) => [{ ...adminTranscriptReviewKeys.styleFixManifests()[0], jobId }] as const,
  styleFixChunks: () => [{ ...adminTranscriptReviewKeys.all[0], scope: 'styleFixChunk' }] as const,
  styleFixChunk: (jobId: string, chunkIndex: number) =>
    [{ ...adminTranscriptReviewKeys.styleFixChunks()[0], jobId, chunkIndex }] as const,
};
